import { render } from "./MainAppPage.vue?vue&type=template&id=94e0b028&scoped=true&ts=true"
import script from "./MainAppPage.vue?vue&type=script&lang=ts"
export * from "./MainAppPage.vue?vue&type=script&lang=ts"

import "./MainAppPage.vue?vue&type=style&index=0&id=94e0b028&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94e0b028"]])

export default __exports__